/*
Author: Chathuraka Mallawa Arachchi
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

import {SingleChoice} from "@/components/Atoms";
import InputLabel from "@/components/Atoms/InputLabel";
import {useResponseId,useUrlType} from "@/components/hooks";
import {RootState} from "@/reducers/store";
import {useValidate} from "@/state/survey/formSlice";
import {BasicAnswerSave,useUpdateAnswersSubmit} from "@/state/survey/saveAnswerSlice";
import {Utility} from "@/utils";
import {useEffect,useRef,useState} from "react";
import {useSelector} from "react-redux";
import poaAnswerDetails from "../../SurveyModel/poaQuestions/poaAnswerDetails";
import {nodeConfigurations} from "../../SurveyModel/types/nodeTypes";

const SingleChoiceNode = (props:any) => {
    const {node, name, children } = props;
    const form = useSelector((state:RootState) => state.form);
    const validateInputField = useValidate();
    const [questionName, setQuestionName] = useState('') 
    const updateAnswersDispatch = useUpdateAnswersSubmit();
    const hasExecuted = useRef(false);
    const {answerResponseId} = useResponseId();
    const [inputValue, setInputValue ] = useState(form[node.name] && form[node.name].value);
    const {isPatient} = useUrlType()
  
   

    useEffect(()=>{
        if(form[node.name] && form[node.name].value !== inputValue){
            setInputValue(form[node.name].value )
        }
    }, [form, inputValue]);

    const handleChange = (value: any) => {
        validateInputField(node.name, value, true);
        if(node.validationDependants) {
            node.validationDependants.forEach((element : string)=> {
                validateInputField(element, form[element].value, true);
            });
        }
    
    }

    const handleOnBlur = () => {
        if(!isPatient && answerResponseId) {
            const answers: BasicAnswerSave[] = poaAnswerDetails.generateQuestionAnswerSubmitFormat(form,node )
            updateAnswersDispatch(answers, answerResponseId);
        }  
    }

    useEffect(()=>{
        if(!isPatient && name && form[node.name] && questionName != name && !hasExecuted.current){ //poa only
            validateInputField(name, form[node.name].value, true);
            setQuestionName(name)
            hasExecuted.current = true;
        }
    }, [form, questionName, node, isPatient, name,validateInputField ])
    
    return (
        <div className={`single-choice-wrap user-input 
        ${Utility.getClassForWidthPx(node)}  
        ${node.name}
        ${Utility.getClassForWidth(node)} 
        question-bottom-space-1 
        single-chocie-choices-wrap flex-1 ${!isPatient ? 'poa-input': '' } input-border-top`
        }>
            <InputLabel label={node.title} labelClasses="input-label"></InputLabel>
            {node.subTitle ? <InputLabel type="subTitle" label={node.subTitle } labelClasses="input-label"></InputLabel> : ''}
            <SingleChoice role="radiogroup"  aria-label={node.title} onBlur={handleOnBlur} propClasses={`single-chocie-choices flex ${node.configurations?.some((config: nodeConfigurations) => config.key === "AnswerDirection" && config.value === "Vertical") ? "single-chocie-choices-vertical" : ""}`} value={form[node.name] && form[node.name].value} options={node.options} name={node.name} onChange={handleChange}/>
            <div>{children}</div>
        </div>
    )
}

export default SingleChoiceNode;